import { ViewStyle } from 'react-native';
import { Styles } from '../../types/styles';
import { Easing, WithTimingConfig } from 'react-native-reanimated';

export const SKELETON_DEFAULT_STYLES: Styles<ViewStyle> = {
  borderRadius: 'radius-400',
  backgroundColor: 'primaryBackground',
};

export const SKELETON_TIMING_CONFIG: WithTimingConfig = {
  duration: 2000,
  easing: Easing.inOut(Easing.quad),
};
